import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Alert,
  CircularProgress,
  Box,
  Grid,
} from "@mui/material";
import { updateOrder } from "../../../../../services/Admin/OrdersApi";
import {
  getDeliveryUsers,
  getCaptainOrderUsers,
  getTablesWithOrders,
} from "../../../../../services/Admin/SalesScreenApi";
import { getTablesList } from "../../../../../services/Admin/TablesApi";

const EditeOrderDataDilog = ({ open, onClose, order, onUpdated }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [deliveryUsers, setDeliveryUsers] = useState([]);
  const [loadingDelivery, setLoadingDelivery] = useState(false);
  const [captainOrderUsers, setCaptainOrderUsers] = useState([]);
  const [loadingCaptain, setLoadingCaptain] = useState(false);
  const [tables, setTables] = useState([]);
  const [loadingTables, setLoadingTables] = useState(false);

  const [formData, setFormData] = useState({
    table_id: null,
    captain_order_id: null,
    delivery_id: null,
    date: "",
  });

  const currentOrderType = order?.order_type || order?.type;
  const hideTableAndCaptainFields =
    currentOrderType === "delivery" || currentOrderType === "takeaway";
  const currentOrderId = order?.id || order?.order_id;

  const getTableActiveOrder = (table) => {
    const activeOrder = table?.active_order || table?.activeOrder || table?.order || null;
    if (!activeOrder || typeof activeOrder !== "object") return null;
    return Object.keys(activeOrder).length ? activeOrder : null;
  };

  const isSameCurrentOrder = (activeOrder) => {
    const activeOrderId = activeOrder?.id || activeOrder?.order_id;
    return activeOrderId && currentOrderId && String(activeOrderId) === String(currentOrderId);
  };

  const isTableDisabled = (table) => {
    const activeOrder = getTableActiveOrder(table);
    return Boolean(activeOrder) && !isSameCurrentOrder(activeOrder);
  };

  // تحميل بيانات الطلب الحالية عند فتح الديالوج
  useEffect(() => {
    if (open && order) {
      setFormData({
        table_id: order.table_id || null,
        captain_order_id: order.captain_order_id || null,
        delivery_id: order.delivery_id || null,
        date: order.date || new Date().toISOString().split("T")[0],
      });
      setError("");
      setSuccess(false);

      // جلب قائمة الديليفري والقباطنة والطاولات
      loadDeliveryUsers();
      loadCaptainOrderUsers();
      loadTables();
    }
  }, [open, order]);

  // جلب قائمة مناديب التوصيل
  const loadDeliveryUsers = async () => {
    setLoadingDelivery(true);
    try {
      const response = await getDeliveryUsers();
      setDeliveryUsers(response.data || []);
    } catch (err) {
      console.error("خطأ في جلب مناديب التوصيل:", err);
      setDeliveryUsers([]);
    } finally {
      setLoadingDelivery(false);
    }
  };

  // جلب قائمة الطاولات
  const loadTables = async () => {
    setLoadingTables(true);
    try {
      const response = await getTablesWithOrders();
      setTables(response.data || []);
    } catch (err) {
      console.error("خطأ في جلب الطاولات المشغولة، سيتم جلب قائمة الطاولات فقط:", err);
      try {
        const fallbackResponse = await getTablesList();
        setTables(fallbackResponse.data || []);
      } catch (fallbackErr) {
        console.error("خطأ في جلب الطاولات:", fallbackErr);
        setTables([]);
      }
    } finally {
      setLoadingTables(false);
    }
  };

  // جلب قائمة قباطنة الطلب
  const loadCaptainOrderUsers = async () => {
    setLoadingCaptain(true);
    try {
      const response = await getCaptainOrderUsers();
      setCaptainOrderUsers(response.data || []);
    } catch (err) {
      console.error("خطأ في جلب قباطنة الطلب:", err);
      setCaptainOrderUsers([]);
    } finally {
      setLoadingCaptain(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value === "" ? null : value,
    }));
    setError("");
  };

  const validateForm = () => {
    // التحقق من أن التاريخ موجود
    if (!formData.date) {
      setError("التاريخ مطلوب");
      return false;
    }

    // التحقق من أن نوع الطلب موجود
    if (!(order?.order_type || order?.type)) {
      setError("نوع الطلب مطلوب");
      return false;
    }

    if (currentOrderType === "tables" && formData.table_id) {
      const selectedTable = tables.find((table) => String(table.id) === String(formData.table_id));
      if (selectedTable && isTableDisabled(selectedTable)) {
        setError("لا يمكن اختيار هذه الطاولة لأنها عليها طلب نشط بالفعل");
        return false;
      }
    }

    return true;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    setLoading(true);
    setError("");
    setSuccess(false);

    try {
      const orderType = order.order_type || order.type;

      const response = await updateOrder({
        order_id: order.id,
        status: order.status,
        table_id:
          orderType === "tables" && formData.table_id
            ? parseInt(formData.table_id)
            : null,
        captain_order_id:
          orderType === "tables" && formData.captain_order_id
            ? parseInt(formData.captain_order_id)
            : null,
        delivery_id:
          orderType === "delivery" && formData.delivery_id
            ? parseInt(formData.delivery_id)
            : null,
        date: formData.date,
        order_type: orderType,
      });

      setSuccess(true);

      // إغلاق الديالوج بعد 1.5 ثانية
     setSuccess(true);
onUpdated?.(response);
onClose();
    } catch (err) {
      console.error("خطأ في تحديث بيانات الطلب:", err);
      setError(err.message || "حدث خطأ في تحديث البيانات");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      dir="rtl"
    >
      <DialogTitle sx={{ fontWeight: "bold", textAlign: "right" }}>
        تعديل بيانات الطلب
      </DialogTitle>

      <DialogContent sx={{ pt: 3 }}>
        {/* Error Alert */}
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        {/* Success Alert */}
        {success && (
          <Alert severity="success" sx={{ mb: 2 }}>
            تم تحديث البيانات بنجاح
          </Alert>
        )}

        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <TextField
            label="حالة الطلب"
            value={order?.status || "-"}
            fullWidth
            disabled
          />

          <TextField
            label="نوع الطلب"
            value={order?.order_type || order?.type || "-"}
            fullWidth
            disabled
          />

          {/* التاريخ */}
          <TextField
            label="التاريخ"
            name="date"
            type="date"
            value={formData.date}
            onChange={handleChange}
            fullWidth
            disabled={loading}
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{
              dir: "rtl",
            }}
            required
          />

          <Grid container spacing={1}>
            {!hideTableAndCaptainFields && (
              <>
                {/* الطاولة */}
                <Grid item xs={6}>
                  <FormControl fullWidth disabled={loading || loadingTables}>
                    <InputLabel id="table-label">الطاولة</InputLabel>
                    <Select
                      labelId="table-label"
                      name="table_id"
                      value={formData.table_id || ""}
                      onChange={handleChange}
                      label="الطاولة"
                    >
                      <MenuItem value="">
                        <em>بدون طاولة</em>
                      </MenuItem>
                      {loadingTables ? (
                        <MenuItem disabled>
                          <CircularProgress size={20} sx={{ mr: 1 }} />
                          جاري التحميل...
                        </MenuItem>
                      ) : (
                        tables.map((table) => {
                          const disabled = isTableDisabled(table);
                          const activeOrder = getTableActiveOrder(table);
                          const activeOrderNumber =
                            activeOrder?.general_increment ||
                            activeOrder?.daily_increment ||
                            activeOrder?.id ||
                            activeOrder?.order_id;

                          return (
                          <MenuItem key={table.id} value={table.id} disabled={disabled}>
                            {table.name || `طاولة ${table.id}`}
                            {disabled && ` - مشغولة${activeOrderNumber ? ` بطلب #${activeOrderNumber}` : ""}`}
                          </MenuItem>
                          );
                        })
                      )}
                    </Select>
                  </FormControl>
                </Grid>

                {/* معرّف كابتن الطلب */}
                <Grid item xs={6}>
                  <FormControl fullWidth disabled={loading || loadingCaptain}>
                    <InputLabel id="captain-label">قبطان الطلب</InputLabel>
                    <Select
                      labelId="captain-label"
                      name="captain_order_id"
                      value={formData.captain_order_id || ""}
                      onChange={handleChange}
                      label="قبطان الطلب"
                    >
                      <MenuItem value="">
                        <em>بدون قبطان طلب</em>
                      </MenuItem>
                      {loadingCaptain ? (
                        <MenuItem disabled>
                          <CircularProgress size={20} sx={{ mr: 1 }} />
                          جاري التحميل...
                        </MenuItem>
                      ) : (
                        captainOrderUsers.map((captain) => (
                          <MenuItem key={captain.id} value={captain.id}>
                            {captain.name} - {captain.phone}
                          </MenuItem>
                        ))
                      )}
                    </Select>
                  </FormControl>
                </Grid>
              </>
            )}

            {/* معرّف التوصيل */}
            {currentOrderType !== "tables" && (
              <Grid item xs={12}>
                <FormControl fullWidth disabled={loading || loadingDelivery}>
                  <InputLabel id="delivery-label">مندوب التوصيل</InputLabel>
                  <Select
                    labelId="delivery-label"
                    name="delivery_id"
                    value={formData.delivery_id || ""}
                    onChange={handleChange}
                    label="مندوب التوصيل"
                  >
                    <MenuItem value="">
                      <em>بدون مندوب توصيل</em>
                    </MenuItem>
                    {loadingDelivery ? (
                      <MenuItem disabled>
                        <CircularProgress size={20} sx={{ mr: 1 }} />
                        جاري التحميل...
                      </MenuItem>
                    ) : (
                      deliveryUsers.map((delivery) => (
                        <MenuItem key={delivery.id} value={delivery.id}>
                          {delivery.name} - {delivery.phone}
                        </MenuItem>
                      ))
                    )}
                  </Select>
                </FormControl>
              </Grid>
            )}
          </Grid>
        </Box>
      </DialogContent>

      <DialogActions sx={{ p: 2 }}>
        <Button
          onClick={onClose}
          disabled={loading}
          variant="outlined"
        >
          إلغاء
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          color="primary"
          disabled={loading}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          {loading && <CircularProgress size={20} color="inherit" />}
          {loading ? "جاري الحفظ..." : "حفظ التعديلات"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditeOrderDataDilog;
